import { MENU_SCREEN } from "../../../menu.types";
import bg2 from "../../../assets/images/shop-card-bg.webp";
/*import bg1 from "../../../assets/images/bg-1.webp";
import bagIcon from "../../../assets/images/bag.png";
import bg3 from "../../../assets/images/bg-2.webp";
import bg4 from "../../../assets/images/bg-3.webp";
import inventoryIcon from "../../../assets/images/inventory-bag.webp";
import paperIcon from "../../../assets/images/paper-icon.webp";
 */
import packIcon from "../assets/images/pack-icon.webp";
import caseIcon from "../assets/images/case.png";
import containersBg from "../assets/images/containers-bg-square.webp";
import starterPackBg from "../assets/images/starter-bg-square.webp";
import { CONTAINERS_ITEM, STARTER_PACK } from "../../shop/constants";

export interface ContentItem {
  id: string;
  label: string;
  description: string;

  size: "large" | "small" | "tall";
  backgroundImageSrc?: string;
  iconSrc?: string;
  accent: string;
  screen?: MENU_SCREEN;
  objectFitCover?: boolean;
  redirectTo?: string;
  ctaText: string | null;
}

const contentItems: ContentItem[] = [
  /* {
    id: "job-uri",
    label: "JOB-URI",
    description:
      "Lorem ipsum is simply dummy text of the printing and typesetting industry.",
    iconSrc: bagIcon,
    size: "large",
    accent: "#2a6e8a",
    screen: MENU_SCREEN.Jobs,
    ctaText: "ACCESEAZA",
    backgroundImageSrc: bg1,
  }, */
  /** {
    id: "backpacks",
    label: "Backpacks",
    description:
      "Lorem ipsum is simply dummy text of the printing and typesetting industry.",
    backgroundImageSrc: bg3,
    iconSrc: inventoryIcon,
    size: "small",
    accent: "#1fa89e",
    screen: MENU_SCREEN.Backpacks,
    ctaText: null,
  },
  {
    id: "reguli",
    label: "REGULI",
    description:
      "Lorem ipsum is simply dummy text of the printing and typesetting industry.",
    backgroundImageSrc: bg4,
    iconSrc: paperIcon,
    size: "small",
    accent: "#1fa89e",
    screen: MENU_SCREEN.Rules,

    ctaText: null,
  }, */
  {
    id: STARTER_PACK.id,
    label: STARTER_PACK.name,
    description: STARTER_PACK.description,
    backgroundImageSrc: starterPackBg,
    size: "small",
    ctaText: "",
    objectFitCover: true,
    accent: "",
    iconSrc: packIcon,
  },
  {
    id: CONTAINERS_ITEM.id,
    label: CONTAINERS_ITEM.name,
    description: CONTAINERS_ITEM.description,
    backgroundImageSrc: containersBg,
    screen: MENU_SCREEN.Containers,
    iconSrc: caseIcon,
    size: "small",
    objectFitCover: true,

    ctaText: "",
    accent: "",
  },
  {
    id: "shop",
    label: "SHOP",
    description:
      "Lorem ipsum is simply dummy text of the printing and typesetting industry.",
    backgroundImageSrc: bg2,
    size: "tall",
    accent: "#2a6e8a",
    screen: MENU_SCREEN.Shop,
    ctaText: "ACCESEAZA",
  },
];

export default contentItems;
